module.exports = __webpack_public_path__ + "img/digital-chart - Copy.bd8b8d7f.svg";